var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let ChatSessionCard = class ChatSessionCard extends LitElement {
    constructor() {
        super(...arguments);
        this.selected = false;
    }
    handleClick() {
        this.dispatchEvent(new CustomEvent('chat-session-click', {
            detail: this.chatSession,
            bubbles: true,
            composed: true,
        }));
    }
    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    render() {
        return html `
      <basic-selectable-card .selected="${this.selected}" @card-clicked="${this.handleClick}">
        <div class="ggo-chat-session-card__content">
          <span class="ggo-chat-session-card__name">${this.chatSession.name || msg('Unnamed session', { id: 'chatSession.card.unnamedSession', desc: 'Unnamed session placeholder' })}</span>
          <span class="ggo-chat-session-card__date">${this.formatDate(this.chatSession.updated_at)}</span>
        </div>
      </basic-selectable-card>
    `;
    }
};
ChatSessionCard.styles = css `
    :host {
      display: block;
      cursor: pointer;
    }

    .ggo-chat-session-card__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .ggo-chat-session-card__name {
      margin: 0;
      font-size: 1rem;
      color: #333;
      font-weight: 600;
    }

    .ggo-chat-session-card__date {
      font-size: 0.75rem;
      color: #999;
    }
  `;
__decorate([
    property({ type: Object })
], ChatSessionCard.prototype, "chatSession", void 0);
__decorate([
    property({ type: Boolean })
], ChatSessionCard.prototype, "selected", void 0);
ChatSessionCard = __decorate([
    localized(),
    customElement('chat-session-card')
], ChatSessionCard);
export { ChatSessionCard };
//# sourceMappingURL=ChatSessionCard.js.map